import { Info } from '@huspy/briks-icons';
import { Flex, Text } from '@huspy/briks-web';
import { useTranslation } from 'react-i18next';

export const EditRestrictionMessage = ({ isVisible }: {
  isVisible: boolean;
}) => {
  const { t } = useTranslation();
  if (!isVisible) {
    return null;
  }
  return (
    <Flex
      data-test='edit-restriction-message'
      position='sticky'
      justify='center'
      align='center'
      bottom='20px'
      width='100%'
    >
      <Flex
        backgroundColor='blue.100'
        justify='center'
        align='center'
        width='fit-content'
        p='2'
        borderRadius='2'
        gap='2'
      >
        <Info />
        <Text size='md'>
          {t('clients.formSections.cantEdit')}
        </Text>
      </Flex>
    </Flex>
  );
};
